import { Routes } from '@angular/router';
import { appGuard } from './guards/app.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [appGuard],
    children: [
      { path: '', redirectTo: 'activations', pathMatch: 'full' },
      { path: 'activate', loadComponent: () => import('./client-activation-form/client-activation-form').then(m => m.ClientActivationForm) },
      { path: 'tasks', loadComponent: () => import('./clickup-board-tasks/clickup-board-tasks').then(m => m.ClickupBoardTasksComponent) },
      { path: 'system-status', loadComponent: () => import('./system-status/system-status').then(m => m.SystemStatusComponent) },
      { path: 'add-feedback', loadComponent: () => import('./add-client-feedback/add-client-feedback').then(m => m.AddClientFeedbackComponent) },
      { path: 'create-issue-form', loadComponent: () => import('./create-issue-form/create-issue-form').then(m => m.CreateIssueFormComponent) },
      {
        path: 'activations',
        children: [
          { path: '', loadComponent: () => import('./activations/activations').then(m => m.ActivationsComponent) },
          {
            path: ':id',
            children: [
              {
                path: '',
                loadComponent: () => import('./activation-detail/activation-detail').then(m => m.ActivationDetailComponent),
                data: { skipPrerender: true }
              },
              {
                path: 'subscriptions',
                loadComponent: () => import('./customer-subscriptions/customer-subscriptions.component').then(m => m.CustomerSubscriptionsComponent),
                data: { skipPrerender: true }
              }
            ]
          }
        ]
      }
    ]
  },
  { path: 'unauthorized', loadComponent: () => import('./components/unauthorized.component').then(m => m.UnauthorizedComponent) },
  { path: '**', redirectTo: '/unauthorized' }
];
